module.exports = __webpack_public_path__ + "static/media/mascot-2@2x.cb6e7911.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mascot/mascot-2@2x.png
// module id = 995
// module chunks = 0